
export const CatholicHouseholdActionTypes = Object.freeze({
  CATHOLIC_HOUSEHOLD_VIEW: 'catholic-household-view',
  CATHOLIC_HOUSEHOLD_MEMBER: 'catholic-household-member',
  CATHOLIC_HOUSEHOLD_IMPORT: 'catholic-household-import',
  CATHOLIC_HOUSEHOLD_CREATE: 'catholic-household-create',
  CATHOLIC_HOUSEHOLD_UPDATE: 'catholic-household-update',
  CATHOLIC_HOUSEHOLD_DELETE: 'catholic-household-delete',
  CATHOLIC_HOUSEHOLD_APPROVE: 'catholic-household-approve',
  CATHOLIC_HOUSEHOLD_UNDO_APPROVE: 'catholic-household-undo-approve',
  CATHOLIC_HOUSEHOLD_SHARE: 'catholic-household-share',
})
